export const checkIfNumber = (str: string) => {
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  if (typeof str === "string") {
    for (var i = 0; i < str.length; i++) {
      if (
        englishNumbers.includes(str[i]) ||
        persianNumbers.includes(str[i]) ||
        arabicNumbers.includes(str[i])
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
